<div class="layout-row layout-align-start-center"
     [ngbTooltip]="isHideTooltip ? null : tooltipTmpl" openDelay="300" triggers="hover">

  <app-bringoz-state-link class="flex text-ellipsis"
                          [state]="'depot.shipper-accounts'"
                          [permission]="'depots.get'"
                          [params]="{id: depot.id}"
                          [text]="depot.name">
  </app-bringoz-state-link>

</div>

<ng-template #tooltipTmpl>
  <div class="layout-column">
    <span>{{depot.name}}</span>
    <span *ngIf="address">{{address | bringozAddress}}</span>
    <span *ngIf="phone">{{phone | bringozPhone}}</span>
    <span *ngIf="additionalPhone">{{additionalPhone | bringozPhone}}</span>
  </div>
</ng-template>



